import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=bf74d9be&scoped=true&"
import script from "./Refresh.vue?vue&type=script&lang=js&"
export * from "./Refresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf74d9be",
  null
  
)

export default component.exports